import type { ReactNode } from "react";
import { AGENT_PLAYBOOK_LABELS as P, PLATFORM } from "../labels.ts";
import { ServiceLogo, type ServiceBrand } from "./service-logo.tsx";
import { Chip } from "./status.tsx";

/** Channel names and marks stay identical in lists, properties and reviews. */
export const channelName = (channel: string) => PLATFORM[channel] ?? P.channel[channel] ?? channel;

const BRANDS: Readonly<Record<string, ServiceBrand>> = {
  github: "github", hackernews: "hackernews", reddit: "reddit", stackexchange: "stackexchange",
  x: "x", linkedin: "linkedin", bluesky: "bluesky", mastodon: "mastodon",
};

export function ChannelLogo({ channel, size = 16 }: { channel: string; size?: number }) {
  const key = channel.startsWith("r/") ? "reddit" : channel.startsWith("se/") ? "stackexchange" : channel;
  return Object.hasOwn(BRANDS, key) ? <ServiceLogo service={BRANDS[key]} size={size} /> : null;
}

export function ChannelName({ channel, children }: { channel: string; children?: ReactNode }) {
  return <span className="z-service-name"><ChannelLogo channel={channel} />{children ?? channelName(channel)}</span>;
}

export function ChannelChip({ channel, children }: { channel: string; children?: ReactNode }) {
  return <Chip icon={<ChannelLogo channel={channel} size={12} />}>{children ?? channelName(channel)}</Chip>;
}
